import { MutationObserverOptions, useMutation } from 'react-query';

import {
  queryClient,
  claimBrnReward,
  IClaimBrnRewardInput,
  ClaimBrnRewardOutput,
} from 'clients/api';
import FunctionKey from 'constants/functionKey';
import { useComptrollerContract } from 'clients/contracts/hooks';

type Options = MutationObserverOptions<
  ClaimBrnRewardOutput,
  Error,
  Omit<IClaimBrnRewardInput, 'comptrollerContract' | 'brainiacLensContract'>
>;

const useClaimBrnReward = (options?: Options) => {
  const comptrollerContract = useComptrollerContract();

  return useMutation(
    FunctionKey.CLAIM_BRN_REWARD,
    (params: Omit<IClaimBrnRewardInput, 'comptrollerContract' | 'brainiacLensContract'>) =>
      claimBrnReward({
        comptrollerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: async (...onSuccessParams) => {
        queryClient.resetQueries(FunctionKey.GET_BRN_REWARD);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useClaimBrnReward;
